const apiUrls = require('../../constants/apiUrls');

const orderCloseValidation = {
    key: 'orderCloseValidation',
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.CLOSE_VALIDATION_URL}?orderSystem=${request.billingSystem}&accountNumber=${request.accountNumber}&orderId=${request.orderId}`;
    },
    dependencies: [
        {
            key: 'orderDetails',
            requestProps: [
                {
                    path: [
                        'details', 'accountNumber'
                    ],
                    propName: 'accountNumber'
                }
            ]
        }, {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'billingSystem'
                    ],
                    propName: 'billingSystem'
                }
            ]
        }, {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'serviceOrderInfoV2', 'serviceOrderId'
                    ],
                    propName: 'orderId'
                }
            ]
        }
    ]
};

export default orderCloseValidation;


// WEBPACK FOOTER //
// ./src/store/order-details-config/orderCloseValidation.js